import React from "react";

// Full-screen image popup — same idea as the mobile app's photo-viewer
// Modal (tap a thumbnail, see it full-size, tap anywhere to close), used
// wherever a page shows clickable photo thumbnails instead of opening the
// image in a new browser tab.
function ImageLightbox({ url, onClose }) {
  if (!url) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.9)", zIndex: 1000,
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "zoom-out", padding: "24px",
      }}
    >
      <img
        src={url}
        alt="Full size"
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: "6px" }}
      />
    </div>
  );
}

export default ImageLightbox;
